import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-5" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { key: 2 }

import { getUserTenancy, tenancies } from "@/core/types/TenantTypes";
import UserDocuments from "@/projects/tenant/modules/users/components/UserDocuments.vue";
import UserFinancial from "@/projects/tenant/modules/users/components/UserFinancial.vue";
import UserAuFinancial from "@/projects/tenant/modules/users/components/UserAuFinancial.vue";
import UserStart from "@/projects/tenant/modules/users/components/UserStart.vue";
import UserQuizs from "@/projects/tenant/modules/users/components/UserQuizs.vue";
import UserInfos from "@/projects/tenant/modules/users/components/UserInfos.vue";
import UserAgreement from "@/projects/tenant/modules/users/components/UserAgreement.vue";
import { useStore } from "@/store";
import { onMounted, ref } from "vue";

const enum VerificationTab {
  Started = "Started",
  Info = "Info",
  Financial = "Financial",
  Quiz = "Quiz",
  Agreement = "Agreement",
  Document = "Document",
  PersonalInfos = "Personal",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserVerifyCheck',
  props: {
    verificationDetails: {}
  },
  setup(__props: any) {

const props = __props;



const store = useStore();
const user = store.state.AuthModule.user;

const currentTab = ref(VerificationTab.Started);
const verificationDetails = ref<any>({});

const handleSelect = (key: VerificationTab, keyPath: string[]) => {
  currentTab.value = key;
};

onMounted(async () => {
  verificationDetails.value = props.verificationDetails;
});

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_menu, {
          "default-active": currentTab.value,
          class: "w-100 mb-5",
          mode: "horizontal",
          onSelect: handleSelect
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, {
              index: VerificationTab.Started
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.started")), 1)
              ]),
              _: 1
            }, 8, ["index"]),
            _createVNode(_component_el_menu_item, {
              index: VerificationTab.Financial
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.financial")), 1)
              ]),
              _: 1
            }, 8, ["index"]),
            _createVNode(_component_el_menu_item, {
              index: VerificationTab.Quiz
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.quiz")), 1)
              ]),
              _: 1
            }, 8, ["index"]),
            _createVNode(_component_el_menu_item, {
              index: VerificationTab.Agreement
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.agreement")), 1)
              ]),
              _: 1
            }, 8, ["index"]),
            _createVNode(_component_el_menu_item, {
              index: VerificationTab.Info
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.info")), 1)
              ]),
              _: 1
            }, 8, ["index"])
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (VerificationTab.Started === currentTab.value)
          ? (_openBlock(), _createBlock(UserStart, {
              key: 0,
              "verification-details": verificationDetails.value
            }, null, 8, ["verification-details"]))
          : _createCommentVNode("", true),
        (VerificationTab.Info === currentTab.value)
          ? (_openBlock(), _createBlock(UserInfos, {
              key: 1,
              "verification-details": verificationDetails.value
            }, null, 8, ["verification-details"]))
          : _createCommentVNode("", true),
        (VerificationTab.Financial === currentTab.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (
              _unref(getUserTenancy)() === _unref(tenancies).au &&
              verificationDetails.value.financial &&
              verificationDetails.value.financial.bg1 == null &&
              verificationDetails.value.financial.bg2 == null
            )
                ? (_openBlock(), _createBlock(UserAuFinancial, {
                    key: 0,
                    "verification-details": verificationDetails.value
                  }, null, 8, ["verification-details"]))
                : (_openBlock(), _createBlock(UserFinancial, {
                    key: 1,
                    "verification-details": verificationDetails.value
                  }, null, 8, ["verification-details"]))
            ]))
          : _createCommentVNode("", true),
        (VerificationTab.Quiz === currentTab.value)
          ? (_openBlock(), _createBlock(UserQuizs, {
              key: 3,
              "verification-details": verificationDetails.value
            }, null, 8, ["verification-details"]))
          : _createCommentVNode("", true),
        (VerificationTab.Agreement === currentTab.value)
          ? (_openBlock(), _createBlock(UserAgreement, {
              key: 4,
              "verification-details": verificationDetails.value
            }, null, 8, ["verification-details"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})